export default __webpack_public_path__ + "static/media/1041.f25b5497.png";